import { isMemberImportDiagnosticResponse, } from '@urbanik/api-contracts';
export class MemberImportDiagnosticApiError extends Error {
    kind;
    constructor(kind, message) {
        super(message);
        this.kind = kind;
        this.name = 'MemberImportDiagnosticApiError';
    }
}
export async function getMemberImportDiagnostic(baseUrl, signal) {
    let response;
    try {
        response = await fetch(`${baseUrl.replace(/\/$/, '')}/identity/member-import/diagnostic`, {
            headers: { Accept: 'application/json' },
            credentials: 'include',
            signal: signal ?? null,
        });
    }
    catch {
        throw new MemberImportDiagnosticApiError('unavailable', 'No pudimos leer la fuente histórica.');
    }
    if (response.status === 401)
        throw new MemberImportDiagnosticApiError('unauthorized', 'Debes iniciar sesión.');
    if (response.status === 403)
        throw new MemberImportDiagnosticApiError('forbidden', 'No tienes permiso para diagnosticar la fuente.');
    let payload;
    try {
        payload = await response.json();
    }
    catch {
        throw new MemberImportDiagnosticApiError('invalid', 'El servidor devolvió una respuesta inválida.');
    }
    if (!response.ok)
        throw new MemberImportDiagnosticApiError('unavailable', typeof payload.message === 'string'
            ? payload.message
            : 'No pudimos completar el diagnóstico.');
    if (!isMemberImportDiagnosticResponse(payload))
        throw new MemberImportDiagnosticApiError('invalid', 'El contrato del diagnóstico no es válido.');
    return payload;
}
